__turbopack_context__.v({
  "Sticky": "styles-module__MTwDSW__Sticky",
});
